export default from './Heading';



// WEBPACK FOOTER //
// ./src/components/atoms/Heading/index.js